import { render, staticRenderFns } from "./attendinfocopy.vue?vue&type=template&id=4486a4de&scoped=true"
import script from "./attendinfocopy.vue?vue&type=script&lang=js"
export * from "./attendinfocopy.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/attendinfo.css?vue&type=style&index=0&id=4486a4de&prod&scoped=true&lang=css&external"
import style1 from "./attendinfocopy.vue?vue&type=style&index=1&id=4486a4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4486a4de",
  null
  
)

export default component.exports